module.exports = __webpack_public_path__ + "img/progress_icn.517ec1f1.svg";